/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { ModalTitle } from '@atlaskit/modal-dialog';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import Loading from 'src/components/loading';
import { CodeContainer } from 'src/styles';

export const DialogTitle = styled(ModalTitle)`
  justify-content: space-between;
  width: 100%;
`;

export const DialogTitleIcon = styled.span`
  margin-right: ${token('space.100', '8px')};
  flex: 0 0 auto;
`;

export const DialogTitleText = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

export const DiffWrapper = styled.div`
  border: 1px solid ${token('color.border', colors.N40)};
`;

export const ModalLoading = styled(Loading)`
  height: 100%;
`;

export const ScmCommandCodeContainer = styled(CodeContainer)`
  max-width: 540px;
`;

export const FilePath = styled.h2`
  font-size: inherit;
  line-height: inherit;
  color: inherit;
  font-weight: inherit;
  letter-spacing: inherit;
  margin: 0;
  padding: 0;
  word-break: break-word;
  cursor: auto;
  display: flex;
  flex-wrap: wrap;
`;

export const DiffStatusIconWrapper = styled.span`
  padding: 4px;
`;

export const FilePathWrapper = styled.span`
  margin-top: 3px;
  display: flex;
  flex-wrap: wrap;
  font-size: 16pt;
`;
